import { render, staticRenderFns } from "./CvDownload.vue?vue&type=template&id=78e65936&lang=pug&"
import script from "./CvDownload.vue?vue&type=script&lang=ts&"
export * from "./CvDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e65936')) {
      api.createRecord('78e65936', component.options)
    } else {
      api.reload('78e65936', component.options)
    }
    module.hot.accept("./CvDownload.vue?vue&type=template&id=78e65936&lang=pug&", function () {
      api.rerender('78e65936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cvtool-pages/cv-sections/CvDownload.vue"
export default component.exports